// src/pages/HomeScreen.jsx

import { motion } from "framer-motion";
import {
  Card,
  Row,
  Col,
  Button,
  Typography,
  Space,
  Avatar,
  Empty,
  Badge,
} from "antd";
import {
  PlusOutlined,
  BankOutlined,
  ReloadOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  UserOutlined,
  RightOutlined,
  BellOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const HomeScreen = ({
  userDetails,
  walletDetails,
  transactionDetails,
  showBalance,
  toggleBalance,
  getUserDetails,
  expanded,
  setActiveTab,
  renderTransactionItem,
  setShowProfile,
  notifications,
}) => {
  const listVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  console.log("Notifications in HomeScreen:", walletDetails);
  return (
    <>
      <div
        style={{
          height: "100vh", // full screen height
          overflowY: "auto", // vertical scroll only
          overflowX: "hidden", // prevent horizontal scroll
          boxSizing: "border-box", // include padding in width
        }}
      >
        {/* Header */}
        <Row justify="space-between" align="middle" wrap={false}>
          <Col style={{ minWidth: 0 }}>
            <Row
              align="middle"
              onClick={() => setShowProfile(true)}
              wrap={false}
            >
              <Title level={5} style={{ margin: 0, fontSize: "1rem" }}>
                Hi {userDetails?.name} 👋
              </Title>
              <RightOutlined
                style={{
                  marginLeft: 8,
                  fontSize: 14,
                  color: "#1890ff",
                  cursor: "pointer",
                }}
              />
            </Row>
            <Text type="secondary" style={{ fontSize: "0.85rem" }}>
              Personal Wallet
            </Text>
          </Col>
          <Col>
            <Row align="middle" gutter={12} wrap={false}>
              <Col>
                <Badge count={notifications?.length} overflowCount={99}>
                  <BellOutlined
                    style={{
                      fontSize: 20,
                      color: "#1890ff",
                      cursor: "pointer",
                    }}
                    onClick={() => setActiveTab("notifications")}
                  />
                </Badge>
              </Col>
              <Col>
                <Avatar
                  style={{ background: "#1890ff" }}
                  icon={<UserOutlined />}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Balance Card */}
        <Card
          style={{
            marginTop: 16,
            borderRadius: 12,
            background: "linear-gradient(to right, #021B79,#0575E6)",
            color: "#fff",
            width: "100%", // full width on mobile
            boxSizing: "border-box",
          }}
        >
          <div style={{ color: "white" }}>
            <Row justify="space-between" align="middle" wrap={false}>
              <Col style={{ minWidth: 0 }}>
                <Text style={{ color: "white", fontSize: "0.85rem" }}>
                  {userDetails.nationality === "Indian" ? "INR" : "USD"} Wallet
                  Balance
                </Text>
                <Title
                  level={3}
                  style={{ color: "white", margin: 0, fontSize: "1.5rem" }}
                >
                  {showBalance
                    ? parseFloat(walletDetails.totalBalance).toFixed(2)
                    : "•••••••"}
                </Title>
                <br />
                <Text style={{ color: "white", fontSize: "0.85rem" }}>
                  Account: {userDetails.accountNumber}
                </Text>
              </Col>
              <Col style={{ display: "flex", gap: 12 }}>
                <ReloadOutlined
                  onClick={getUserDetails}
                  style={{ cursor: "pointer", color: "white" }}
                />
                {showBalance ? (
                  <EyeInvisibleOutlined
                    onClick={toggleBalance}
                    style={{ color: "white" }}
                  />
                ) : (
                  <EyeOutlined
                    onClick={toggleBalance}
                    style={{ color: "white" }}
                  />
                )}
              </Col>
            </Row>
            <Text type="success">● Active</Text>
          </div>
        </Card>

        {/* Actions */}
        <Card style={{ marginTop: 16, borderRadius: 12, width: "100%" }}>
          <Row gutter={[12, 12]} justify="space-between">
            <Col span={12}>
              <Button
                block
                type="default"
                icon={<PlusOutlined />}
                style={{ borderRadius: 8, fontSize: "0.9rem" }}
                onClick={() => setActiveTab("top-up")}
              >
                Wallet top-up
              </Button>
            </Col>
            <Col span={12}>
              <Button
                block
                type="default"
                icon={<BankOutlined />}
                style={{ borderRadius: 8, fontSize: "0.9rem" }}
              >
                Wallet to bank
              </Button>
            </Col>
          </Row>
        </Card>

        {/* Transfer to */}
        <div style={{ marginTop: 16 }}>
          <Title level={5}>Transfer to</Title>
          <Space style={{ marginTop: 8, flexWrap: "wrap" }}>
            <Avatar
              size={48}
              style={{
                background: "#e6f4ff",
                color: "#1890ff",
                cursor: "pointer",
              }}
              icon={<PlusOutlined />}
            />
            {[1, 2, 3, 4].map((id) => (
              <div key={id} style={{ textAlign: "center" }}>
                <Avatar
                  size={48}
                  style={{ background: "#bae7ff", color: "#1890ff" }}
                  icon={<UserOutlined />}
                />
                <div style={{ fontSize: 12 }}>Alex</div>
              </div>
            ))}
          </Space>
        </div>

        {/* Recent Transactions */}
        <div style={{ marginTop: 24, paddingBottom: 70 }}>
          <Title level={5}>Recent Transactions</Title>
          {transactionDetails?.length > 0 ? (
            <Card style={{ width: "100%" }}>
              <motion.div
                variants={listVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                {(expanded
                  ? transactionDetails
                  : transactionDetails.slice(0, 4)
                ).map((item, idx, arr) => (
                  <motion.div key={idx} variants={itemVariants}>
                    <div style={{ padding: "5px 0" }}>
                      {renderTransactionItem(item)}
                    </div>
                    {idx !== arr.length - 1 && (
                      <div
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          margin: "8px 0",
                        }}
                      />
                    )}
                  </motion.div>
                ))}
              </motion.div>
            </Card>
          ) : (
            <Card style={{ textAlign: "center", width: "100%" }}>
              <Empty
                description="No transactions yet"
                style={{ marginTop: 40 }}
              />
            </Card>
          )}

          {transactionDetails.length > 4 && (
            <Button
              block
              style={{ marginTop: 12, marginBottom: 35, borderRadius: 8 }}
              onClick={() => setActiveTab("history")}
            >
              See all
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default HomeScreen;
